import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onChange", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import Textarea from '../../Textarea';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormTextArea(_ref) {
  var _formField$props, _errors$formField$nam;
  var control = _ref.control,
    formField = _ref.formField,
    errors = _ref.errors;
  var errorStyles = (_formField$props = formField.props) !== null && _formField$props !== void 0 && _formField$props.useTooltip && !!(errors !== null && errors !== void 0 && (_errors$formField$nam = errors[formField.name]) !== null && _errors$formField$nam !== void 0 && _errors$formField$nam.message) ? tooltipErrorStyles : {};
  return _jsx(Flex, _objectSpread(_objectSpread({
    direction: "column"
  }, _objectSpread(_objectSpread(_objectSpread({}, defaultStyles), formField.styles), errorStyles)), {}, {
    "data-fieldname": formField.name,
    "data-testid": formField.testid,
    children: _jsx(Controller, {
      name: formField.name,
      control: control,
      render: _ref2 => {
        var _errors$formField$nam2, _formField$props2;
        var field = _ref2.field;
        var _onChange = field.onChange,
          _ = field.ref,
          extraPropsField = _objectWithoutProperties(field, _excluded);
        return _jsx(Textarea, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          resize: "none"
        }, textareaStyle), formField.props), extraPropsField), {}, {
          value: extraPropsField.value || '',
          placeholder: formField.label,
          error: errors === null || errors === void 0 || (_errors$formField$nam2 = errors[formField.name]) === null || _errors$formField$nam2 === void 0 ? void 0 : _errors$formField$nam2.message,
          onChange: o => {
            var _formField$onChange;
            (_formField$onChange = formField.onChange) === null || _formField$onChange === void 0 || _formField$onChange.call(formField, o.target.value);
            _onChange(o.target.value);
          },
          maxLength: (_formField$props2 = formField.props) === null || _formField$props2 === void 0 ? void 0 : _formField$props2.maxLength
        }));
      }
    })
  }));
}
var textareaStyle = {
  height: '18.75rem',
  border: '1px solid var(--chakra-colors-lightGrey1)'
};
var tooltipErrorStyles = {
  marginBottom: 'var(--chakra-space-6xl)'
};
var defaultStyles = {
  marginBottom: 'var(--chakra-space-md)'
};